/**
 * @generated SignedSource<<25e6ecd02645c0ce5f45d5165baf573d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentInstallmentPlan_charge$data = {
  readonly chargeIntent: {
    readonly id: string;
  } | null | undefined;
  readonly paymentMethods: ReadonlyArray<{
    readonly method?: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentInstallments_charge">;
  readonly " $fragmentType": "PaymentInstallmentPlan_charge";
};
export type PaymentInstallmentPlan_charge$key = {
  readonly " $data"?: PaymentInstallmentPlan_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentInstallmentPlan_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentInstallmentPlan_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Charge",
      "kind": "LinkedField",
      "name": "chargeIntent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "paymentMethods",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "method",
              "storageKey": null
            }
          ],
          "type": "PaymentMethodInstallments",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentInstallments_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "5b44230e26ecfa89e1e577df19b9212e";

export default node;
